import React, { useState } from 'react';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const RegistrationForm = () => {
  const REGISTRATION_PAUSED = true; // Pausar inscripciones
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: '',
    edad: '',
    categoria: '',
    genero: '',
    emergencia: '',
    telefonoEmergencia: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (REGISTRATION_PAUSED) {
      setMessage('Las inscripciones están pausadas. No estamos aceptando más registros en este momento.');
      return;
    }
    
    setIsSubmitting(true);
    setMessage('');

    try {
      // Capacidad máxima: 450 registros
      const snapshot = await getDocs(collection(db, 'registrations'));
      if (snapshot.size >= 450) {
        setMessage('Cupo lleno: se alcanzó el límite de 450 participantes.');
        return;
      }
      // Add document to Firestore
      await addDoc(collection(db, 'registrations'), {
        ...formData,
        fechaRegistro: new Date(),
        timestamp: new Date().toISOString()
      });
      
      setMessage('¡Registro exitoso! Te contactaremos pronto.');
      setFormData({
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        edad: '',
        categoria: '',
        genero: '',
        emergencia: '',
        telefonoEmergencia: ''
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      if (error.code === 'permission-denied') {
        setMessage('Error: Firestore no está configurado correctamente. Contacta al administrador.');
      } else if (error.code === 'unavailable') {
        setMessage('Error: Servicio no disponible. Inténtalo más tarde.');
      } else {
        setMessage('Error al registrar. Por favor, inténtalo de nuevo.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="registration">
      <h2>Registro</h2>
      <div className="form-container">
        {REGISTRATION_PAUSED && (
          <div className="error-message" style={{ marginBottom: '2rem', textAlign: 'center', fontSize: '1.2rem', padding: '1.5rem', backgroundColor: '#fff3cd', border: '2px solid #ffc107', borderRadius: '8px', color: '#856404' }}>
            ⚠️ Las inscripciones están pausadas. No estamos aceptando más registros en este momento.
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre *</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="genero">Género *</label>
            <select
              id="genero"
              name="genero"
              value={formData.genero}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            >
              <option value="">Selecciona una opción</option>
              <option value="hombre">Hombre</option>
              <option value="mujer">Mujer</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="apellido">Apellido *</label>
            <input
              type="text"
              id="apellido"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefono">Teléfono *</label>
            <input
              type="tel"
              id="telefono"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="edad">Edad *</label>
            <input
              type="number"
              id="edad"
              name="edad"
              value={formData.edad}
              onChange={handleChange}
              min="1"
              max="100"
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="categoria">Categoría *</label>
            <select
              id="categoria"
              name="categoria"
              value={formData.categoria}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            >
              <option value="">Selecciona una categoría</option>
              <option value="3km-infantil">3 km Infantil</option>
              <option value="10km-no-competitiva">10 km No competitiva</option>
              <option value="20km-competitiva">20 km Competitiva</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="emergencia">Contacto de Emergencia *</label>
            <input
              type="text"
              id="emergencia"
              name="emergencia"
              value={formData.emergencia}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefonoEmergencia">Teléfono de Emergencia *</label>
            <input
              type="tel"
              id="telefonoEmergencia"
              name="telefonoEmergencia"
              value={formData.telefonoEmergencia}
              onChange={handleChange}
              required
              disabled={REGISTRATION_PAUSED}
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isSubmitting || REGISTRATION_PAUSED}
          >
            {isSubmitting ? 'Registrando...' : 'Registrarse'}
          </button>

          {message && (
            <div className={message.includes('Error') ? 'error-message' : 'success-message'}>
              {message}
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default RegistrationForm;
